import React from 'react';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', morado:'#534AB7' };

export default function ProjectCard({ perfil, ciudad, onVerPerfil, isMobile }) {
  const nombre = perfil.business_name || perfil.full_name || 'Proyecto';
  const descripcion = perfil.presentacion_descripcion || perfil.presentacion_quien || '';
  const queBusca = perfil.presentacion_que_busca || '';
  const imagenUrl = perfil.foto_proyecto || perfil.avatar_url || null;
  const categoryText = [perfil.business_type, perfil.business_stage].filter(Boolean).join(' · ');

  return (
    <div style={{
      display:'flex',
      flexDirection: isMobile ? 'column' : 'row',
      background:'rgba(255,255,255,0.05)',
      backdropFilter:'blur(30px)',
      WebkitBackdropFilter:'blur(30px)',
      border:'1px solid rgba(255,255,255,0.1)',
      borderRadius:24,
      overflow:'hidden',
      transition:'box-shadow 0.3s ease, border-color 0.3s ease',
      cursor:'default',
      fontFamily:font,
      color:'#fff',
      minHeight: isMobile ? 'auto' : 280,
    }}
    onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 0 30px rgba(93,193,185,0.15)'; e.currentTarget.style.borderColor = 'rgba(93,193,185,0.25)'; }}
    onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
    >
      {/* LEFT side — info */}
      <div style={{ flex:1, padding: isMobile ? '20px 18px' : '24px 22px', display:'flex', flexDirection:'column', gap:12 }}>
        {/* Avatar + name */}
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {perfil.avatar_url ? (
            <img src={perfil.avatar_url} alt="" style={{ width:40, height:40, borderRadius:'50%', objectFit:'cover' }} />
          ) : (
            <div style={{ width:40, height:40, borderRadius:'50%', background:'linear-gradient(135deg, #5dc1b9, #FDBE02)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, fontWeight:600, flexShrink:0 }}>
              {nombre[0]}
            </div>
          )}
          <div>
            <p style={{ margin:0, fontSize:15, fontWeight:600, fontFamily:serif }}>{nombre}</p>
            {categoryText && (
              <span style={{ display:'inline-block', marginTop:3, padding:'3px 10px', background:'rgba(255,255,255,0.08)', border:'0.5px solid rgba(255,255,255,0.12)', borderRadius:999, fontSize:11, color:'rgba(255,255,255,0.6)' }}>
                {categoryText}
              </span>
            )}
          </div>
        </div>

        {/* City */}
        {ciudad && <p style={{ margin:0, fontSize:12, color:'rgba(255,255,255,0.45)' }}>📍 {ciudad}</p>}

        {/* Cuéntanos */}
        {descripcion && (
          <div>
            <p style={{ margin:'0 0 4px', fontSize:10, color:'rgba(255,255,255,0.4)', letterSpacing:1, textTransform:'uppercase' }}>Cuéntanos</p>
            <p style={{ margin:0, fontSize:13, color:'rgba(255,255,255,0.8)', lineHeight:1.6 }}>
              {descripcion.length > 150 ? descripcion.slice(0, 150) + '...' : descripcion}
            </p>
          </div>
        )}

        {/* Qué busca */}
        {queBusca && (
          <div>
            <p style={{ margin:'0 0 4px', fontSize:10, color:'rgba(255,255,255,0.4)', letterSpacing:1, textTransform:'uppercase' }}>Qué busca</p>
            <p style={{ margin:0, fontSize:13, color:'rgba(255,255,255,0.8)', lineHeight:1.6 }}>
              {queBusca.length > 120 ? queBusca.slice(0, 120) + '...' : queBusca}
            </p>
          </div>
        )}

        {/* Button */}
        <button onClick={() => onVerPerfil && onVerPerfil(perfil.id)} style={{
          marginTop:'auto',
          padding:'10px 0',
          background:'rgba(255,255,255,0.06)',
          border:'0.5px solid rgba(255,255,255,0.12)',
          borderRadius:10,
          color:C.turquesa,
          fontSize:13,
          fontWeight:500,
          cursor:'pointer',
          fontFamily:'inherit',
          transition:'background 0.2s',
        }}>
          Ver perfil completo →
        </button>
      </div>

      {/* RIGHT side — image */}
      <div style={{
        width: isMobile ? '100%' : 200,
        minHeight: isMobile ? 160 : 'auto',
        background: imagenUrl ? `url(${imagenUrl}) center/cover no-repeat` : 'linear-gradient(135deg, rgba(93,193,185,0.3), rgba(253,190,2,0.2), rgba(83,74,183,0.25))',
        borderRadius: isMobile ? '0 0 24px 24px' : '0 24px 24px 0',
        order: isMobile ? -1 : 1,
      }} />
    </div>
  );
}
